import React from "react";
import { Button } from "../ui/button";
import { usePathname, useRouter } from "next/navigation";
import { animatePageOut } from "@lib/pageAnimate";

type Variant =
  | "outline"
  | "default"
  | "link"
  | "destructive"
  | "secondary"
  | "ghost"
  | null
  | undefined;

interface TransitionLinkProps {
  href: string;
  label?: string | null;
  variant?: Variant;
  className?: string;
  children?: React.ReactNode;
}

function TransitionLink({
  href,
  label,
  variant,
  className,
  children,
}: Readonly<TransitionLinkProps>) {
  const router = useRouter();
  const pathname = usePathname();

  const handleClick = () => {
    if (pathname !== href) {
      animatePageOut(href, router);
    }
  };

  return (
    <Button
      variant={variant ?? "link"}
      className={className ?? "text-lg"}
      onClick={handleClick}
    >
      {label ?? children ?? "Click Me"}
    </Button>
  );
}

export default TransitionLink;
